import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllTasksByRoundAndFiled = createAsyncThunk(
  "YesNo/GetAllTasksByRoundAndFiled",
  async (id, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Tasks/GetAllTasksByRoundAndFiled",
        {
          roundYearId: id.roundYearId,
          fieldId: id.fieldId,
          flowId: id.flowId,
        }
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetSpecificTaskById = createAsyncThunk(
  "YesNo/GetSpecificTaskById",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Tasks/GetSpecificTaskById",
        parameters
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const UpdateMainTasks = createAsyncThunk(
  "YesNo/UpdateMainTasks",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Tasks/UpdateMainTasks",
        parameters
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TasksByRoundAndFiled = createSlice({
  name: "TasksByRoundAndFiled",
  initialState: {
    TasksByRoundAndFiled: {},
    loadingTasksByRoundAndFiled: false,
    errorTasksByRoundAndFiled: null,
    /////////////
    SpecificTask: {},
    loadingSpecificTask: false,
    errorSpecificTask: null,

     /////////////
     UpdateMainTasks: {},
     loadingUpdateMainTasks: false,
     errorUpdateMainTasks: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllTasksByRoundAndFiled.pending, (state, action) => {
        state.loadingTasksByRoundAndFiled = true;
        state.TasksByRoundAndFiled = action.payload;
        state.errorTasksByRoundAndFiled = null;
      })
      .addCase(GetAllTasksByRoundAndFiled.fulfilled, (state, action) => {
        state.loadingTasksByRoundAndFiled = false;
        state.TasksByRoundAndFiled = action.payload;
      })
      .addCase(GetAllTasksByRoundAndFiled.rejected, (state, action) => {
        state.loadingTasksByRoundAndFiled = false;
        state.errorTasksByRoundAndFiled = action.payload;
      });



      builder

      .addCase(GetSpecificTaskById.pending, (state, action) => {
        state.loadingSpecificTask = true;
        state.SpecificTask = action.payload;
        state.errorSpecificTask = null;
      })
      .addCase(GetSpecificTaskById.fulfilled, (state, action) => {
        state.loadingSpecificTask = false;
        state.SpecificTask = action.payload;
      })
      .addCase(GetSpecificTaskById.rejected, (state, action) => {
        state.loadingSpecificTask = false;
        state.SpecificTask = action.payload;
      });

      builder

      .addCase(UpdateMainTasks.pending, (state, action) => {
        state.loadingUpdateMainTasks = true;
        state.UpdateMainTasks = action.payload;
        state.errorUpdateMainTasks = null;
      })
      .addCase(UpdateMainTasks.fulfilled, (state, action) => {
        state.loadingUpdateMainTasks = false;
        state.UpdateMainTasks = action.payload;
      })
      .addCase(UpdateMainTasks.rejected, (state, action) => {
        state.loadingUpdateMainTasks = false;
        state.UpdateMainTasks = action.payload;
      });
  },
});

export default TasksByRoundAndFiled.reducer;
